import { useState, useEffect } from 'react';

function useTempMessage(duration = 3000) {
  const [message, setMessage] = useState('');

  useEffect(() => {
    // If there is a message, set a timeout to clear it after the specified duration
    if (message) {
      const timer = setTimeout(() => {
        setMessage('');
      }, duration);

      // Cleanup: clear the timeout if the component unmounts or the message changes before the timer fires
      return () => clearTimeout(timer);
    }
  }, [message, duration]);

  return [message, setMessage];
}

export default useTempMessage;
